/**
 * Lazy Load.
 *
 * @format
 */
import lozad from 'lozad';

export const startLazyLoad = (): void => {
  /**
   * Lazy Load Images.
   */
  const lazyLoadImages = (): void => {
    const observer = lozad('.lazy', {
      loaded: (element: Element) => {
        element.classList.add('img-loaded');
      },
    });
    observer.observe();
  };
  lazyLoadImages();
};
